import React, { useContext, useEffect, useState } from 'react';
import { Flexbox, Button } from '@sede-enterprise/shell-ds-react-framework';
import { PPASelectFormField } from '../../../../PPAInsights/PPAInsightFilterSection/PPASelectFormField';
import { AppContext } from '../../../../../../Context/AppContext';
import { reconFilterOptions } from '../../../../../../api/services';
import { RECON_DATA_SOURCE_DEFAULT_TRADE_TYPE } from '../../../../../../api/constants';

export const ReconDataSourceFilter = () => {
  const { state: reconState, dispatch: reconDispatch } = useContext(AppContext).reconReports;
  const { state: appDataState } = useContext(AppContext).appData;
  const userRegion = localStorage.getItem('userRegion') ?? appDataState.userRegion;
  // Hardcoded options
  let options: string[];

  switch (userRegion.toLowerCase()) {
    case 'americas':
      options = ['AM_NG', 'AM_PW'];
      break;
    case 'europe':
      options = ['EU_ALIGN', 'EU_GROUP'];
      break;
    case 'asia':
      options = ['JP_PW', 'PH_PW', 'IN_PW'];
      break;
    case 'australia':
      options = ['AU_NG'];
      break;
    default:
      options = ['AM_NG', 'AM_PW', 'EU_ALIGN', 'EU_GROUP', 'JP_PW', 'AU_NG', 'PH_PW', 'IN_PW'];
      break;
  }

  const [dataSourceSelected, setDataSourceSelected] = useState(options[0]);
  const [generatedData, setGeneratedData] = useState('');
  useEffect(() => {
    // call the function if the options is set to one value while logging in, this is for user with specific region
    // Set the default trade type based on the selected data source
    const tradeType =
      RECON_DATA_SOURCE_DEFAULT_TRADE_TYPE[
        dataSourceSelected as keyof typeof RECON_DATA_SOURCE_DEFAULT_TRADE_TYPE
      ];
    if (options.length === 1) {
      reconDispatch({ type: 'setReconRegion', payload: dataSourceSelected });
      let transactionType = 'BUY';

      if (dataSourceSelected === 'EU_GROUP') {
        transactionType = 'NET';
      }

      const payload = {
        ...reconState.ReconfilteredValues,
        dataSource: dataSourceSelected,
        tradeType,
        transactionType,
      };
      reconDispatch({ type: 'setReconFilteredValues', payload });
    } else {
      const payload = {
        ...reconState.ReconfilteredValues,
        dataSource: dataSourceSelected,
        tradeType,
      };
      reconDispatch({ type: 'setReconFilteredValues', payload });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleGenerateData = async () => {
    reconDispatch({ type: 'setReconRegion', payload: dataSourceSelected });
    // Mocking data generation based on the selected report
    if (dataSourceSelected) {
      let tradeType = 'PW';
      let transactionType = 'BUY';
      let ncfCategories = reconState.ReconfilteredValues.ncfCategory;
      if (dataSourceSelected === 'AM_NG' || dataSourceSelected === 'AU_NG') {
        tradeType = 'NG';
      }

      if (dataSourceSelected === 'EU_GROUP') {
        transactionType = 'NET';
      }

      if (dataSourceSelected === 'EU_ALIGN' || dataSourceSelected === 'EU_GROUP') {
        tradeType = reconState.ReconfilteredValues.tradeType ?? 'PW';
      }

      if (dataSourceSelected === 'AS_PW' || dataSourceSelected === 'AU_NG') {
        ncfCategories = [];
      }

      const payload = {
        ...reconState.ReconfilteredValues,
        dataSource: dataSourceSelected,
        transactionType,
        tradeType,
        pageNumber: 1,
        pageSize: 10,
        ruleApplied: 'YES',
        ncfCategory: ncfCategories,
      };
      reconDispatch({ type: 'setReconFilteredValues', payload });

      const reconFilterOptionsResponse = await reconFilterOptions({
        dataSource: dataSourceSelected,
      });
      reconDispatch({
        type: 'setReconFilterOptions',
        payload: reconFilterOptionsResponse.data,
      });
    } else {
      setGeneratedData('Please select a report to generate data.');
    }
  };

  return (
    <div data-testid='filter' style={{ width: '60%' }}>
      <Flexbox flexDirection='row' alignItems='flex-start' gap='20px'>
        <PPASelectFormField
          id='report'
          label='Select the Data Source'
          testId='Report'
          value={dataSourceSelected}
          onChange={setDataSourceSelected}
          options={options}
          disabled={options.length === 1}
        />
        <Button
          className='getDataBtn'
          data-testid='Generate Data'
          onClick={handleGenerateData}
          style={{ marginLeft: '10px', marginTop: '24px', width: '162px', border: '1px solid' }}
          disabled={options.length === 1}
        >
          Generate Data
        </Button>
      </Flexbox>
      {generatedData && <div style={{ marginTop: '20px' }}>{generatedData}</div>}
    </div>
  );
};
